module.exports = __WEBPACK_EXTERNAL_MODULE__1948__;